<template>
 <div id="containerbar" class="containerbar authenticate-bg">
        <!-- Start Container -->
        <div class="container">
            <div class="auth-box login-box">
                <!-- Start row -->
                <div class="row no-gutters align-items-center justify-content-center">
                    <!-- Start col -->
                    <div class="col-md-6 col-lg-5">
                        <!-- Start Auth Box -->
                        <div class="auth-box-right">
                            <div class="card">
                                <div class="card-body">


                                    <form  @submit.prevent="attemptLogin" action="#">
                                        <div class="form-head">
                                            <a href="/" class="logo" id="expired"
                                             
                                            ><avatar :username="cuser.firstname+' '+cuser.lastname" :size="100" /></a>
                                        
                                         
                                        </div>                                        
                                       <div class="text-center m-3">
                                         <h4 class="page-title">  Cambia la tua password</h4>
                                       </div>
                                        <div class="form-group">
                                            <input type="password" class="form-control" id="username" placeholder="Nuova password" v-model="user.username" required="">
                                        </div>
                                       <div class="form-group">
                                            <input type="password" class="form-control" id="password" placeholder="Ripeti password" v-model="user.password" required="">
                                        </div>
                                        <b-row v-if="errormessage!=''">
                                        <b-col cols="12" class="text-center alert alert-danger">
                                            {{errormessage}}
                                        </b-col>

                                    </b-row>   
                                    <b-row v-if="successmessage!=''">
                                        <b-col cols="12" class="text-center alert alert-success">
                                            {{successmessage}}
                                        </b-col>

                                    </b-row>                      
                                      <button type="submit" class="btn btn-success btn-lg btn-block font-18 mb-3">Cambia la tua password</button>

                                    </form>
                                   
                                </div>
                            </div>
                        </div>
                        <!-- End Auth Box -->
                    </div>
                    <!-- End col -->
                </div>
                <!-- End row -->
            </div>
        </div>
        <!-- End Container -->
    </div>
</template>
<style scoped>
#expired .vue-avatar--wrapper{
display: inline-flex!important;

}
</style>
<script>
import axios from 'axios';

export default {
  name: 'ViewLogin',
  data() {
    return {
      user: {
        username: '',
        password: ''
      },
      errormessage: '',
      successmessage:''
    };
  },
  computed:{

      cuser() {
      return this.$store.state.user;
    },
  },
  methods: {
      attemptLogin() {
          var me = this;
     me.successmessage = me.errormessage = "";
         
             axios.post('user/changePassword', {
                      username: me.user.username,
                      password:me.user.password
                  }).then(response => {

                      if (response.status == 200 && !response.data.error) {
                           me.$store.commit('authUser', { user: response.data });
                                        this.$router.push({ name: 'route-index' });
                      }
                      else {
                          me.errormessage = 'Controlla che le password coincidano';
                      }


                  }) 
                  .catch(error => {
                      console.log(error);
                      me.errormessage = 'Controlla che le password coincidano';
                  });


          
     
    }
  }
};
</script>
